import React from 'react'

import ResponsiveImage from '../../display/ResponsiveImage'
import type { ResponsiveImageProperties } from '../../display/ResponsiveImage/types'

import CardSlider from './CardSlider'

type Photo = {
  image: ResponsiveImageProperties
}

type Props = {
  photos: Photo[]
} & React.ComponentProps<typeof CardSlider>

export default ({ photos, ...props }: Props) => (
  <React.Fragment>
    {photos?.length > 1 ? (
      <CardSlider photos={photos} {...props} />
    ) : (
      photos[0] && <ResponsiveImage {...photos[0].image} zIndex={1} cover />
    )}
  </React.Fragment>
)
